var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('a-divider',{attrs:{"orientation":"left"}},[_vm._v(_vm._s(_vm.$t('business.label.customerCategory')))]),_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('a-directory-tree',{attrs:{"selectedKeys":_vm.selectedKeys,"treeData":_vm.treeData},on:{"select":_vm.onSelected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }